import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useColors, i18n, SUPPORT_LANGUAGES } from "@inbody/core";
import CheckIcon from "@mui/icons-material/Check";
import LanguageIcon from "@mui/icons-material/Language";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { HeaderIconButton } from "./HeaderIconButton.js";
const LANGUAGE_SELECT_WIDTH = 180;
function LanguageChangeButton({
  fontSize = "medium",
  size
}) {
  const { t } = useTranslation("ui");
  const { gray, brand } = useColors();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClickLanguageMenu = useCallback(
    (event) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );
  const handleCloseLanguageMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);
  const handleChangeLanguage = useCallback((language) => {
    i18n.changeLanguage(language);
    setAnchorEl(null);
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      HeaderIconButton,
      {
        "aria-haspopup": "true",
        "aria-expanded": open ? "true" : void 0,
        onClick: handleClickLanguageMenu,
        children: /* @__PURE__ */ jsx(LanguageIcon, { fontSize, sx: { width: size, height: size } })
      }
    ),
    /* @__PURE__ */ jsxs(
      Popover,
      {
        anchorEl,
        open,
        onClose: handleCloseLanguageMenu,
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        slotProps: {
          paper: {
            sx: {
              borderRadius: 2,
              border: `1px solid ${gray[100]}`,
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              minWidth: LANGUAGE_SELECT_WIDTH,
              mt: 1,
              overflow: "hidden"
            }
          }
        },
        children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              sx: {
                px: 2.5,
                py: 1.5,
                borderBottom: `1px solid ${gray[100]}`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              },
              children: /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body2",
                  sx: { fontWeight: 700, color: gray[800] },
                  children: t("언어 선택")
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(Box, { sx: { py: 0.5 }, children: Object.entries(SUPPORT_LANGUAGES).map(([langKey, langVal]) => {
            var _a;
            const selected = ((_a = i18n) == null ? void 0 : _a.language) === langKey;
            return /* @__PURE__ */ jsxs(
              MenuItem,
              {
                onClick: () => handleChangeLanguage(langKey),
                sx: {
                  px: 2.5,
                  py: 1.25,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color: selected ? brand[500] : gray[700],
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: gray[50],
                    color: brand[500]
                  }
                },
                children: [
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "body2",
                      sx: { fontWeight: selected ? 600 : 500 },
                      children: langVal
                    }
                  ),
                  selected && /* @__PURE__ */ jsx(CheckIcon, { sx: { fontSize: 16 } })
                ]
              },
              langKey
            );
          }) })
        ]
      }
    )
  ] });
}
export {
  LanguageChangeButton
};
